/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/*jslint white: true */
/*jslint node: true */
/*global $, jQuery, Swiper, ScrollMagic*/

// slider acf
if (objects.is_onepage || objects.is_front_page) {


	var swiper = new Swiper('.swiper-actu', {
		autoplay: {
			delay: 3000,
		},
		speed: 600,
		pagination: {
			el: '.swiper-actu .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-actu .swiper-button-next',
			prevEl: '.swiper-actu .swiper-button-prev',
		},

		breakpoints: {
			992: {
				direction: 'vertical',
			}
		},
		touchReleaseOnEdges : true

	});



	var swiper = new Swiper('.partenaires .swiper-partenaires', {
		speed: 600,
		slidesPerView: 3,
		spaceBetween: 30,
		navigation: {
			nextEl: '.partenaires .swiper-button-next',
			prevEl: '.partenaires .swiper-button-prev',
		},

		breakpoints: {
			992: {
				slidesPerView: 5,
			}
		}
	});


	var swiper = new Swiper('.avis .swiper-avis-1', {
		speed: 600,
		spaceBetween: 30,
		pagination: {
			el: '.avis .swiper-pagination-1',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.avis .swiper-button-next-1',
			prevEl: '.avis .swiper-button-prev-1',
		},
	});

	var swiper = new Swiper('.avis .swiper-avis-2', {
		speed: 600,
		spaceBetween: 30,
		pagination: {
			el: '.avis .swiper-pagination-2',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.avis .swiper-button-next-2',
			prevEl: '.avis .swiper-button-prev-2',
		},
	});

};